<template>
  <MainLayout selectMenu="1-1" siderMenu="18-1" sideBar="machine">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Upload :action="importUrl" ref="prodSpotFileUpload" name="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :show-upload-list="false"
        style="display: none" :on-success="successImport" :on-error="errorImport">
      </Upload>
      <Row type="flex" class="normal-line menu-actions">
        <Col flex="3">
        <Button type="primary" size="small" icon="md-refresh" @click.native="prodspotRefreshFunc()">{{ getTranslation("s030")
        }}</Button>&nbsp;
        <Button type="success" size="small" icon="md-cloud-upload" @click.native="prodspotImport()">{{ getTranslation("k026")
        }}</Button>&nbsp;
        <Button type="warning" size="small" icon="md-checkmark-circle" @click.native="prodspotValid()">{{ getTranslation("s031")
        }}</Button>&nbsp;
        <Button type="info" size="small" icon="md-cloud-download" @click.native="prodspotExport()">{{ getTranslation("k025")
        }}</Button>&nbsp;
        <Button type="error" size="small" icon="md-trash" @click.native="prodspotClear()">{{ getTranslation("s032") }}</Button>&nbsp;
        <Button type="primary" size="small" icon="md-add" @click.native="prodspotNew()">{{ getTranslation("s033") }}</Button>&nbsp;
        <Button type="success" size="small" icon="md-download" @click.native="prodspotDownload()">{{ getTranslation("k023")
        }}</Button>       
        </Col>
        <Col flex="2" class="flex-right">
        <Button type="info" size="small" icon="md-funnel" @click="colShowVisible = true">{{ getTranslation('u113') }}</Button>&nbsp;
        <Input v-model="spotId" @on-enter="queryData()" size="small" style="width:200px" :placeholder="getTranslation('k259')" />&nbsp;
        <Input v-model="spotName" @on-enter="queryData()" size="small" style="width:100px" :placeholder="getTranslation('k241')" />&nbsp;
        <Input v-model="program" @on-enter="queryData()" size="small" style="width:80px" :placeholder="getTranslation('b006')" />&nbsp;        
        <Input v-model="spotModel" @on-enter="queryData()" size="small" style="width:80px" :placeholder="getTranslation('k258')" />&nbsp;
        <Tooltip :content="getTranslation('k176')" placement="bottom" theme ="light" :transfer="true">      
        <Button type="primary" size="small" @click.native="queryData()" shape="circle" icon="ios-search"></Button></Tooltip>&nbsp;
        <Tooltip :content="getTranslation('e020')" placement="bottom" theme ="light" :transfer="true">
          <Button type="error" size="small" @click.native="emptyQuery()" shape="circle" icon="ios-refresh"></Button></Tooltip>
      </Col>
      </Row>
      <Affix>
      <Row class="table-header" type="flex" style="flex-wrap: nowrap;overflow: visible !important;">
        <Col flex="2" class="table-cell" :style="colStyle('1')" ref="col-ref-1" v-show="showCol('1')">{{ getTranslation('k259') }}
          <span class="col-resizer" @mousedown="startResize('1', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('2')" ref="col-ref-2" v-show="showCol('2')">{{ getTranslation('k241') }}
          <span class="col-resizer" @mousedown="startResize('2', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('3')" ref="col-ref-3" v-show="showCol('3')">{{ getTranslation('b006') }}
          <span class="col-resizer" @mousedown="startResize('3', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('4')" ref="col-ref-4" v-show="showCol('4')">{{ getTranslation('k243') }}
          <span class="col-resizer" @mousedown="startResize('4', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('5')" ref="col-ref-5" v-show="showCol('5')">{{ getTranslation('k244') }}
          <span class="col-resizer" @mousedown="startResize('5', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('6')" ref="col-ref-6" v-show="showCol('6')">{{ getTranslation('k258') }}
          <span class="col-resizer" @mousedown="startResize('6', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('7')" ref="col-ref-7" v-show="showCol('7')">{{ getTranslation('k379') }}
          <span class="col-resizer" @mousedown="startResize('7', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('8')" ref="col-ref-8" v-show="showCol('8')">{{ getTranslation('k380') }}
          <span class="col-resizer" @mousedown="startResize('8', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('9')" ref="col-ref-9" v-show="showCol('9')">{{ getTranslation('k381') }}
          <span class="col-resizer" @mousedown="startResize('9', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('10')" ref="col-ref-10" v-show="showCol('10')">{{ getTranslation('k247') }}
          <span class="col-resizer" @mousedown="startResize('10', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('11')" ref="col-ref-11" v-show="showCol('11')">{{ getTranslation('k248') }}
          <span class="col-resizer" @mousedown="startResize('11', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('12')" ref="col-ref-12" v-show="showCol('12')">{{ getTranslation('k249') }}
          <span class="col-resizer" @mousedown="startResize('12', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('13')" ref="col-ref-13" v-show="showCol('13')">{{ getTranslation('k250') }}
          <span class="col-resizer" @mousedown="startResize('13', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('14')" ref="col-ref-14" v-show="showCol('14')">{{ getTranslation('k251') }}
          <span class="col-resizer" @mousedown="startResize('14', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('15')" ref="col-ref-15" v-show="showCol('15')">{{ getTranslation('k252') }}
          <span class="col-resizer" @mousedown="startResize('15', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('16')" ref="col-ref-16" v-show="showCol('16')">{{ getTranslation('k253') }}
          <span class="col-resizer" @mousedown="startResize('16', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('17')" ref="col-ref-17" v-show="showCol('17')">{{ getTranslation('k254') }}
          <span class="col-resizer" @mousedown="startResize('17', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('18')" ref="col-ref-18" v-show="showCol('18')">{{ getTranslation('m017') }}
          <span class="col-resizer" @mousedown="startResize('18', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('19')" ref="col-ref-19" v-show="showCol('19')">{{ getTranslation('m018') }}
          <span class="col-resizer" @mousedown="startResize('19', $event)"></span>
        </Col>
      </Row>
    </Affix>
      <div v-if="loadingData" class="progress-container">
        <div class="progress-wrapper">
          <i-circle :size="80" :percent="calProgress" >
            <span class="circle-percent">{{calProgress}}%</span>
          </i-circle>
          <div class="progress-text">{{progressTitle}}：{{ calSuccess }}/{{ calTotal }}</div>
        </div>
      </div>
      <div v-else>
        <Row v-for="(item,index) in prodspot" :key="item.id" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex"
        style="flex-wrap: nowrap;overflow: visible !important;">
          <Col flex="2" class="table-cell" :style="colStyle('1')" v-show="showCol('1')" >
            <Tooltip :content="getTranslation('e015')" placement="right" theme="light" :transfer="true">
              <div @click="copyContent(item.spotId)">{{ item.spotId }}</div>
            </Tooltip>
          </Col>
          <Col flex="2" class="table-cell" :style="colStyle('2')" v-show="showCol('2')">{{ item.spotName }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('3')" v-show="showCol('3')">{{ item.spotProg }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('4')" v-show="showCol('4')">{{ item.spotPss }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('5')" v-show="showCol('5')">{{ item.spotThk }}
          </Col>
          <Col flex="2" class="table-cell" :style="colStyle('6')" v-show="showCol('6')">{{ item.spotModel }}
          </Col>
          <Col flex="2" class="table-cell" :style="colStyle('7')" v-show="showCol('7')">{{ item.spotX }}
          </Col>
          <Col flex="2" class="table-cell" :style="colStyle('8')" v-show="showCol('8')">{{ item.spotY }}
          </Col>
          <Col flex="2" class="table-cell" :style="colStyle('9')" v-show="showCol('9')">{{ item.spotZ }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('10')" v-show="showCol('10')">{{ item.plateName1 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('11')" v-show="showCol('11')">{{ item.plateThk1 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('12')" v-show="showCol('12')">{{ item.plateName2 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('13')" v-show="showCol('13')">{{ item.plateThk2 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('14')" v-show="showCol('14')">{{ item.plateName3 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('15')" v-show="showCol('15')">{{ item.plateThk3 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('16')" v-show="showCol('16')">{{ item.plateName4 }}
          </Col>
          <Col flex="1" class="table-cell" :style="colStyle('17')" v-show="showCol('17')">{{ item.plateThk4 }}
          </Col>
          <Col flex="2" class="table-cell" :style="colStyle('18')" v-show="showCol('18')">{{ item.updated_string }}
          </Col>
          <Col flex="1" class="table-cell flex-middle" :style="colStyle('19')" v-show="showCol('19')">
            <Tooltip :content="getTranslation('m019')" placement="bottom" theme ="light" :transfer="true">
          <Button size="small" type="primary" icon="md-create" @click.native="edit(item.id)"></Button>
          </Tooltip>&nbsp;
          <Tooltip :content="getTranslation('m027')" placement="bottom" theme ="light" :transfer="true">
          <Button size="small" type="error" icon="md-trash" 
            @click.native="del(item.id)"></Button>
            </Tooltip>
          </Col>
        </Row>      
      <Row type="flex">
        <Col flex="1">
        <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
          @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
          :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }}
          {{ getTranslation('c011') }}</Page>
        </Col>
      </Row>
      </div>
      <ProdspotEdit v-model="modalVisible" :propVisible="modalVisible" :editId="editId" @refresh-page="refreshPage">
      </ProdspotEdit>
      <ProdspotCol v-model="colShowVisible" :propVisible="colShowVisible" @record-col-change="initCol"></ProdspotCol>
      <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
    </div>
  </MainLayout>
</template>
<script>

import { API_URL, PAGE_SIZE_ARY } from '@/constants/const';
import MainLayout from '@/components/MainLayout.vue'
import axios from 'axios';
import { mapState,mapGetters, mapMutations } from 'vuex'
import { Row, Col, Page, Button, Upload, Input, Circle,Tooltip,Affix } from "view-design"
import { setSidbarBreadCrumb, exportFile, blobToString, postJsError, setDashboardPage,copyContent  } from '@/util/util.js'
import ProdspotEdit from './components/ProdspotEdit.vue';
import NoAuth from '@/components/NoAuth.vue'
import WebSocket from '@/components/WebSocket.vue';
import ProdspotCol from './components/ProdspotCol.vue';
export default {
  name: 'ProdSpotIndex', // 组件名称
  components: {
    MainLayout, Row, Col, Page, Button, Upload, ProdspotEdit, Input, NoAuth, WebSocket, Tooltip, Affix,
    "i-circle":Circle,ProdspotCol
  },
  watch: {
  },
  computed: {
    ...mapGetters(['getTranslation']),
    ...mapState(['prodSpotRefresh']),
    importUrl() {
      return API_URL["prodspotImport"] + '?mac=' + this.mac;
    },
    calProgress() {
      if (this.showProgress && this.progressJson && this.progressJson.total > 0) {
        let percent = Math.floor((this.progressJson.processed / this.progressJson.total) * 100);
        return percent;
      } else {
        return 0;
      }
    },
    calSuccessProgress() {
      if (this.showProgress && this.progressJson && this.progressJson.total > 0) {
        let successCount = this.progressJson.processed - this.progressJson.errors;
        let percent = Math.floor((successCount / this.progressJson.total) * 100);
        return percent;
      } else {
        return 0;
      }
    },
    calSuccess() {
      if (this.showProgress && this.progressJson) {
        let successCount = this.progressJson.processed - this.progressJson.errors;
        return successCount;
      } else {
        return 0;
      }
    },
    calTotal() {
      if (this.showProgress && this.progressJson) {
        return this.progressJson.total;
      } else {
        return 0;
      }
    },
    webSocketUrl() {
      return API_URL['webSocket'] + "?kind=list&mac=" + this.$route.query.mac;
    },
    progressTitle(){
      let rs = this.getTranslation('d023');
      if(this.progressType == 'prodspot_refresh'){
        rs = this.getTranslation('d001')
      }else if(this.progressType == 'prodspot_import'){
        rs = this.getTranslation('d022')
      }else if(this.progressType == 'prodspot_valid'){
        rs = this.getTranslation('d024')
      }else if(this.progressType == 'prodspot_clear'){
        rs = this.getTranslation('d025')
      }else if(this.progressType == 'prodspot_download'){
        rs = this.getTranslation('d026')
      }
      return rs;
    }
  },
  data() {
    return {
      prodspot: [],
      total: 0,
      current: 1,
      pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
      mac: -1,
      modalVisible: false,
      editId: 0,
      spotId: '',
      pageSizeAry: PAGE_SIZE_ARY,
      hasAuth: true,
      loadingData: false,
      showProgress: false,
      progressJson: null,
      progressType:"",
      program:'',
      spotName:'',
      spotModel:'',
      colWidths: {
      },
      resizing: null,
      colShowVisible: false,
      showColKeys: [],
    }
  },
  mounted() {

  },
  created() {
    setDashboardPage('prodspot');
    this.init();
  },
  methods: {
    ...mapMutations(['setProdSpotRefresh']),
    init() {
      this.mac = this.$route.query.mac
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      this.initCol();
      this.initMachine();
      this.$nextTick(() => {
        this.loadColWidths();
        this.initHeaderWidths();
      })
    },
    initMachine() {
      let url = API_URL["recordInit"];
      let params = {
        mac: this.mac
      }      
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$store.commit('setBreadcrumbItems', [
              { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
            ]);            
            if (res.data.data.machine && res.data.data.machine.state == 1){              
                if(this.prodSpotRefresh && this.prodSpotRefresh.length>0){
                  let found = this.prodSpotRefresh.findIndex(item=>item==this.mac);
                  if(found==-1){
                    this.$store.commit('setProdSpotRefresh', [...this.prodSpotRefresh,this.mac])
                    this.prodspotRefreshFunc();
                  }else {
                    this.getData();
                  }
                }else {
                  this.$store.commit('setProdSpotRefresh', [this.mac])
                  this.prodspotRefreshFunc();
                }                
            }else {
              if(this.prodSpotRefresh && this.prodSpotRefresh.length>0){
                let found = this.prodSpotRefresh.findIndex(item=>item==this.mac);
                if(found!=-1){
                  let newArr = this.prodSpotRefresh.filter(item=>item!=this.mac);
                  this.$store.commit('setProdSpotRefresh', newArr)
                }
              }
              this.getData();
            }     

          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          }
        })
    },
    copyContent(content){      
      if (copyContent(content)){ 
        this.$Message.success(this.getTranslation('u091'));
      } else {
        this.$Message.error(this.getTranslation('u092'));
      }
    },
    getData() {
      this.loadingData = false;
      let url = API_URL["prodspotGet"];
      let params = {
        mac: this.mac,
        page: this.current,
        page_size: this.pageSize,
        spotId: this.spotId,
        spotName: this.spotName,
        program: this.program,
        spotModel: this.spotModel,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.prodspot = res.data.data.data;
            this.total = res.data.data.total;
            this.pageSize = res.data.data.pagination.page_size;
            this.current = res.data.data.pagination.page;
            

          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    emptyQuery(){
      this.spotId = "";
      this.spotName = "";
      this.program = "";
      this.spotModel = "";
      this.current =1;
      this.getData();
    },
    queryData(){
      this.current =1;
      this.getData();
    },
    handlePageChange(page) {
      this.current = page;
      this.getData();
    },
    prodspotRefreshFunc() {
      this.current =1;
      this.progressJson = null;
      this.loadingData = true;
      let url = API_URL["prodspotRefresh"];
      let params = {
        mac: this.mac,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code != 200 && res.data.msg) {
             this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    async prodspotExport() {
      let url = API_URL["prodspotExport"] + '?mac=' + this.mac
      const response = await axios.get(url, {
        responseType: 'blob',
        timeout: 300000,
      });
      if (response.status == 200) {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          blobToString(response.data).then(text => {
            let msgData = JSON.parse(text);
            if (msgData.msg) {
              this.$Message.error(msgData.msg)
            }
          }).catch((err) => {
            postJsError(err)
            this.$Message.error(this.getTranslation('c001'));
          });
        } else {
          exportFile(response)
        }
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }

    },
    prodspotImport() {
      let _this = this;
      this.$Modal.confirm({
        title: "",
        content: this.getTranslation('r109'),
        okText: this.getTranslation('b181'),
        cancelText: this.getTranslation('b182'),
        onOk: () => {
          _this.$refs.prodSpotFileUpload.$el.querySelector('input[type="file"]').click();
        }
      });
    },
    errorImport() {
      this.$Message.error(this.getTranslation('c001'));
    },
    successImport(response) {
      if (response && response.code == 200) {
        this.progressJson = null;
        this.progressType = '';
        this.loadingData = true;
      } else if (response && response.msg) {
        this.errDialog = true;
        this.$Modal.error({
          title: "",
          content: response.msg.replace(/\n/g, '<br>'),
          okText: this.getTranslation('b181'),
          onOk: () => {
           
          }
        })
        
      }
    },
    prodspotValid() {
      let url = API_URL["prodspotValid"];

      let params = {
        mac: this.mac,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
             this.progressJson = null;
             this.progressType = '';
             this.loadingData = true;
          } else if (res && res.data && res.data.msg) {
             this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    prodspotClear() {
      this.$Modal.confirm({
        title: "",
        content: this.getTranslation('d013'),
        okText: this.getTranslation('s032'),
        cancelText: this.getTranslation('b182'),
        onOk: () => {
          let url = API_URL["prodspotClear"];

          let params = {
            mac: this.mac,
          }
          axios.get(url, {
            params: params
          })
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.progressJson = null;
                this.progressType = '';
                this.loadingData = true;
              } else if (res && res.data && res.data.msg) {
                 this.$Modal.error({
                width: 50,
                title: this.getTranslation("r098"),
                content: res.data.msg.replace(/\n/g, '<br>'),
                okText: this.getTranslation("m063"),
              });
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        }
      });
    },
    prodspotDownload() {
      let url = API_URL["prodspotDownload"];
      let params = {
        mac: this.mac,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.progressJson = null;
            this.progressType = '';
            this.loadingData = true;
          } else if (res && res.data && res.data.msg) {
             this.$Modal.error({
              width: 50,
              title: this.getTranslation("r098"),
              content: res.data.msg.replace(/\n/g, '<br>'),
              okText: this.getTranslation("m063"),
            });
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    del(id) {
      this.$Modal.confirm({
        title: "",
        content: this.getTranslation('b055'),
        okText: this.getTranslation('m027'),
        cancelText: this.getTranslation('b182'),
        onOk: () => {
          let url = API_URL["prodspotDelete"];
          let params = {
            mac: this.mac,
            id: id,
          }
          axios.get(url, {
            params: params
          })
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.msg);
                this.getData();
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        }
      });

    },
    refreshPage() {
      this.getData();
    },
    prodspotNew() {
      this.editId = 0,
        this.modalVisible = true;
    },
    edit(id) {
      this.editId = id,
        this.modalVisible = true;
    },
    handlePageSizeChange(pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      localStorage.setItem('user.page_size', this.pageSize)
      this.getData();
    },
    receiveMessage(obj) {
      if (obj && obj.kind) {
        switch (obj.kind) {
          case 'progress':
            if(obj.data && obj.data.mac_id == this.mac){
            if (obj.data && (obj.data.type == 'prodspot_refresh_reset' || obj.data.type =='prodspot_import_reset'|| 
            obj.data.type =='prodspot_validreset' || obj.data.type =='prodspot_clear_reset' || obj.data.type =='prodspot_download_reset' )) {
              this.progressType = obj.data.type;
              this.progressJson = obj.data;
            } else if (obj.data && (obj.data.type == 'prodspot_refresh' || obj.data.type =='prodspot_import' || 
            obj.data.type =='prodspot_valid' || obj.data.type =='prodspot_clear'|| obj.data.type =='prodspot_download')) {
              this.progressType = obj.data.type;
              this.showProgress = true;
              if (!this.progressJson || this.progressJson.processed < obj.data.processed) {
                //避免进度发送错乱时，进度回退                
                this.progressJson = obj.data;
                if (this.progressJson.processed == this.progressJson.total) {
                  this.getData();
                }
              }
            } else if (obj.data && (obj.data.type == 'prodspot_refresh_failed' || obj.data.type == 'prodspot_import_failed'|| 
            obj.data.type == 'prodspot_valid_failed' || obj.data.type == 'prodspot_clear_failed'|| obj.data.type == 'prodspot_download_failed')) {
              this.$Message.error(obj.data.msg);
              this.getData();
            }
          }
            break;
          case "notice":
            var dat = obj.data
            if (dat && dat.msg) {
              this.$Message.info(dat.msg);
            }
            break;
          default:
            break;
        }
      }
    },
    showCol(key){
      if (!this.showColKeys || this.showColKeys.length ==0){
        return true;
      }
      return this.showColKeys.includes(key);
    },
    colStyle(key) {
      const w = this.getColWidth(key);
      const basis = w || 100;
      const isLast = key === '22';
      const style = {
        // allow other columns to shrink to fit; pin last column to the right
        flex: isLast ? `0 0 ${basis}px` : `1 1 ${basis}px`,
        minWidth: '40px',
        position: 'relative'
      };
      if (isLast) style.marginLeft = 'auto';
      return style;
    },
    getColWidth(key) {
      const ref = this.$refs[`col-ref-${key}`];
      const current = this.colWidths[key];
      return current || (ref && ref.$el ? ref.$el.clientWidth : '');
    },
    startResize(key, e) {
      const startX = e.clientX;
      const startWidth = this.getColWidth(key);
      this.resizing = { key, startX, startWidth };
      window.addEventListener('mousemove', this.onResizeMouseMove);
      window.addEventListener('mouseup', this.stopResizeMouseMove);
      e.preventDefault();
    },
    onResizeMouseMove(e) {
      if (!this.resizing) return;
      const delta = e.clientX - this.resizing.startX;
      const newWidth = Math.max(60, this.resizing.startWidth + delta);
      this.$set(this.colWidths, this.resizing.key, newWidth);
    },
    stopResizeMouseMove() {
      if (!this.resizing) return;
      window.removeEventListener('mousemove', this.onResizeMouseMove);
      window.removeEventListener('mouseup', this.stopResizeMouseMove);
      this.saveColWidths();
      this.resizing = null;
    },
    loadColWidths() {
      try {
        const raw = localStorage.getItem('prodspot.colWidths');
        if (raw) {
          const parsed = JSON.parse(raw);
          this.colWidths = { ...this.colWidths, ...parsed };
        }
      } catch (_) {console.log(_)}
    },
    saveColWidths() {
      try {
        localStorage.setItem('prodspot.colWidths', JSON.stringify(this.colWidths));
      } catch (_) {console.log(_)}
    },
    initCol(){
      const raw = localStorage.getItem('prodspot.showCols');      
      if (raw) {
          try {
              const parsed = JSON.parse(raw);
              if (parsed && typeof parsed === 'object') {
                  this.showColKeys = parsed;
              }
          } catch (_) { /* ignore */ }
      }
    },
     initHeaderWidths() {
      for (let i = 1; i <= 19; i++) {
        const key = String(i);
        if (!this.colWidths[key]) {
          const ref = this.$refs[`col-ref-${key}`];
          if (ref && ref.$el) {
            this.$set(this.colWidths, key, ref.$el.clientWidth);
          }
        }
      }
    },


  }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');

.progress-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  margin: 20px 0;
 
}

.progress-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.progress-text {
  font-size: 14px;
  color: #515a6e;
  font-weight: 500;
}
.circle-percent{
  color: #1890ff;
  font-size: 18px; 
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.col-resizer {
  position: absolute;
  right: 0px;
  top: 0;
  height: 100%;
  width: 1px;
  cursor: col-resize;
  user-select: none;
  /* subtle visual cue */
  background: rgba(0, 0, 0, 0.1);
}
</style>